import React, { useState, useEffect,useContext } from 'react';
import Context from "../context/context";
import Widget from './Widget';


const Filters = props => {

  const {clearAllFilters, toggleFilterNav, viewResults} = props;
  const {filterNav} = useContext(Context);
  return (
    <>
      {filterNav.map((widget, i) => {
        if (widget.position == "top" || widget.type == "hidden") {
          return <></>
        } else {
          return <Widget
                    key={i}
                    widget={widget}
                    clearAllFilters={clearAllFilters}
                    toggleFilterNav={toggleFilterNav}
                    viewResults={viewResults}
                 />
        }

      })}
    </>
  )
}

export default Filters;
